import styled from 'styled-components';
export const AppsContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  max-width: 100%;
`;
export const HeaderContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TableContainer = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 570px;
`;
export const AppNameCell = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
`;
export const AppName = styled.div `
  color: var(--text-primary);
  font-weight: var(--font-weight-medium);
`;
export const AppDescription = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
`;
export const DescriptionText = styled.p `
  color: var(--text-secondary);
  margin: 0;
`;
